import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  id: "pos-settings-modal",
  class: "settings-dialog modal-footer"
};
var _hoisted_2 = {
  class: "content"
};
var _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ScanSettings = _resolveComponent("ScanSettings");

  var _component_TicketsEmails = _resolveComponent("TicketsEmails");

  var _component_DeviceSettings = _resolveComponent("DeviceSettings");

  var _component_DeviceLocationSettings = _resolveComponent("DeviceLocationSettings");

  var _component_CashDrawerSettings = _resolveComponent("CashDrawerSettings");

  var _component_CompleteWithBalanceSettings = _resolveComponent("CompleteWithBalanceSettings");

  var _component_TerminalsStatus = _resolveComponent("TerminalsStatus");

  var _component_SettingsPaymentMethods = _resolveComponent("SettingsPaymentMethods");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("settings.title")), 1)];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        class: "py-5 px-6",
        onClick: _ctx.hideDialog
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("common.buttons.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        class: "py-5 px-6",
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _ctx.onSave,
        disabled: !_ctx.canSave,
        id: "save-settings-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("common.buttons.save")), 1)];
        }),
        _: 1
      }, 8, ["loading", "onClick", "disabled"])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ScanSettings, {
        ref: "scanSettings"
      }, null, 512), _createVNode(_component_TicketsEmails, {
        ref: "ticketsEmails"
      }, null, 512), !_ctx.hasHardwareInfo ? (_openBlock(), _createBlock(_component_DeviceSettings, {
        key: 0,
        ref: "deviceSettings"
      }, null, 512)) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(function () {
          return [_ctx.hasHardwareInfo ? (_openBlock(), _createBlock(_component_DeviceLocationSettings, {
            key: 0,
            ref: "DeviceLocationSettings"
          }, null, 512)) : _createCommentVNode("", true)];
        }),
        _: 1
      })), _createVNode(_component_CashDrawerSettings, {
        ref: "cashDrawerSettings"
      }, null, 512), _createVNode(_component_CompleteWithBalanceSettings, {
        ref: "CompleteWithBalanceSettings"
      }, null, 512), (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_TerminalsStatus)];
        }),
        _: 1
      })), _createVNode(_component_SettingsPaymentMethods, {
        ref: "settingsPaymentMethods"
      }, null, 512)])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}